import { Transform, TransformFnParams } from 'class-transformer';

export function PhoneNumberObject(code: string, number: string) {
  return Transform(({ obj }) => {
    const codeString = obj[code] as string;
    const normalizeCode = codeString ? (codeString.startsWith('+') ? codeString.slice(1) : codeString) : '';

    if (!normalizeCode && !obj[number]) return null;

    return {
      countryCode: normalizeCode,
      phoneNumber: obj[number],
    };
  });
}

export function PhoneNumberObjectFromJson(obj: any, code: string, number: string) {
  if (!obj[code] && !obj[number]) return null;

  const codeString = obj[code] as string;
  const normalizeCode = codeString ? (codeString.startsWith('+') ? codeString.slice(1) : codeString) : '';

  return {
    countryCode: normalizeCode,
    phoneNumber: obj[number],
  };
}

export function PhoneNumberStringFromJson(obj: any, code: string, number: string) {
  const numberString = obj[number];
  if (!numberString) return '';

  const codeString = obj[code];
  if (!codeString) return numberString;

  const hasPrefix = (codeString as string).startsWith('+');
  return `(${hasPrefix ? '' : '+'}${codeString}) ${numberString}`;
}

export function PhoneNumberString(code: string, number: string) {
  return Transform(({ obj }) => PhoneNumberStringFromJson(obj, code, number));
}

export function AreaCodePhoneNumber() {
  return Transform((params: TransformFnParams) => {
    if (typeof params.value === 'string') {
      const areaCode = params.value.replace(/\+/g, '');
      // Add a plus sign at the beginning
      return `${areaCode}`;
    }

    return params.value;
  });
}
